import ScrollTo from "@stimulus-components/scroll-to"

export default class extends ScrollTo {
  static values = {
    bottomOffset: Number
  }

  connect() {
    super.connect()
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll)
  }

  disconnect() {
    super.disconnect()
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const scrollPosition = window.scrollY
    const offset = this.bottomOffsetValue || 50

    if (scrollPosition >= offset) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.element.classList.remove("opacity-0", "pointer-events-none")
    this.element.classList.add("opacity-100", "pointer-events-auto")
  }

  hide() {
    this.element.classList.remove("opacity-100", "pointer-events-auto")
    this.element.classList.add("opacity-0", "pointer-events-none")
  }
}